// SECTION - auth
export const LOGOUT = 'LOGOUT'
export const REFRESH_TOKEN = 'REFRESH_TOKEN'
// SECTION - app

// SECTION - setting
export const CHANGE_THEME = 'CHANGE_THEME'